import React, { useState } from 'react';
import { Button, Card, CardBody, Col, Container, Input, InputGroup, InputGroupText, Row, Table } from "reactstrap";
import { useNavigate } from 'react-router-dom';
import { PageSubHeader } from 'components/CommonLayouts/PageSubHeader';

const ExistingCandidateProgress = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [roleFilter, setRoleFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [experienceFilter, setExperienceFilter] = useState('');

  const candidatesDetails = [
    {
      candidateId: "C-001",
      candidateName: "Name",
      email: "name@email.com",
      mobile: "9XXXXXXXXX",
      role: "Frontend Developer",
      experience: "3"
    },
    {
      candidateId: "C-012",
      candidateName: "Name",
      email: "name@email.com",
      mobile: "9XXXXXXXXX",
      role: "Frontend Developer",
      experience: "3"
    },
    {
      candidateId: "C-023",
      candidateName: "Name",
      email: "name@email.com",
      mobile: "9XXXXXXXXX",
      role: "Frontend Developer",
      experience: "3"
    },
    {
      candidateId: "C-034",
      candidateName: "Name",
      email: "name@email.com",
      mobile: "9XXXXXXXXX",
      role: "Frontend Developer",
      experience: "4"
    },
    {
      candidateId: "C-045",
      candidateName: "Name",
      email: "name@email.com",
      mobile: "9XXXXXXXXX",
      role: "Frontend Developer",
      experience: "6"
    },
    {
      candidateId: "C-046",
      candidateName: "Name",
      email: "name@email.com",
      mobile: "9XXXXXXXXX",
      role: "Backend Developer",
      experience: "4"
    },
    {
      candidateId: "C-057",
      candidateName: "Name",
      email: "name@email.com",
      mobile: "9XXXXXXXXX",
      role: "Designer",
      experience: "5"
    }
  ];

  // Filter candidates based on search and dropdowns
  const filteredCandidates = candidatesDetails.filter((candidate) => {
    const matchesSearch = candidate.candidateName.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesRole = roleFilter ? candidate.role === roleFilter : true;
    const matchesStatus = statusFilter ? candidate.status === parseInt(statusFilter) : true;
    const matchesExperience = experienceFilter ? candidate.experience === experienceFilter : true;
    return matchesSearch && matchesRole && matchesStatus && matchesExperience;
  });

  // Search handler
  const handleSearchQuery = (e) => {
    setSearchQuery(e.target.value ?? '');
  };

  // Filter handlers
  const handleRoleFilter = (e) => {
    setRoleFilter(e.target.value);
  };

  const handleStatusFilter = (e) => {
    setStatusFilter(e.target.value);
  };

  const handleExperienceFilter = (e) => {
    setExperienceFilter(e.target.value);
  };

  return (
    <div className="page-content" style={{ backgroundColor: '#FAFAFA', minHeight: '100vh' }}>
      <Container fluid className="py-0 px-0">
        <PageSubHeader
          heading={'Add Candidates'}
          routePath={'Home'}
          pageName={'Add Candidates'}
        />
        <Row className="px-4 py-4">
          <Row className="align-items-center">
            <Col className="d-flex p-2 mx-2">
              <InputGroup size="sm" style={{ width: '348px' }} className="elbert-search-group">
                <Input
                  placeholder="Search by candidate name"
                  className="elbert-search"
                  value={searchQuery}
                  onChange={handleSearchQuery}
                />
                <InputGroupText>
                  <span className="fa fa-search"></span>
                </InputGroupText>
              </InputGroup>
              <Input
                type="select"
                className="elbert-search"
                style={{ width: '125px', marginLeft: '16px' }}
                value={statusFilter}
                onChange={handleStatusFilter}
              >
                <option value="">Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </Input>
              <Input
                type="select"
                className="elbert-search"
                style={{ width: '125px', marginLeft: '16px' }}
                value={roleFilter}
                onChange={handleRoleFilter}
              >
                <option value="">Role</option>
                <option value="Frontend Developer">Frontend Developer</option>
                <option value="Backend Developer">Backend Developer</option>
                <option value="Designer">Designer</option>
                <option value="Tester">Tester</option>
              </Input>
              <Input
                type="select"
                className="elbert-search"
                style={{ width: '137px', marginLeft: '16px' }}
                value={experienceFilter}
                onChange={handleExperienceFilter}
              >
                <option value="">Experience</option>
                <option value="3">3 Years</option>
                <option value="4">4 Years</option>
                <option value="5">5 Years</option>
                <option value="6">6 Years</option>
              </Input>
            </Col>
            <Col className="d-flex gap-3 align-items-center justify-content-end">
              <Button
                className="px-5 p-2 rounded-4 text-white"
                style={{ background: '#006438' }}
                onClick={() => navigate('/submit-candidates')}
              >
                Submit
              </Button>
            </Col>
          </Row>
          <Row className="mt-4 px-4">
            <Card>
              <CardBody>
                <div className="table-responsive">
                  <Table className="table mb-0" style={{ border: '0.4px solid #D4D4D4' }}>
                    <thead>
                      <tr>
                        <th></th>
                        <th>Candidate ID</th>
                        <th>Candidate Name</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>Role</th>
                        <th>Experience</th>
                        <th>Resume</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredCandidates.length > 0 ? (
                        filteredCandidates.map((candidate) => (
                          <tr key={candidate.candidateId}>
                            <td>
                              <Input type="checkbox" style={{ width: '17px', height: '17px' }} />
                            </td>
                            <td>{candidate.candidateId}</td>
                            <td>{candidate.candidateName}</td>
                            <td>{candidate.email}</td>
                            <td>{candidate.mobile}</td>
                            <td>{candidate.role}</td>
                            <td>{candidate.experience}</td>
                            <td>
                              <i
                                className="fa-solid fa-paperclip"
                                title="Attach"
                                style={{ color: '#1E9EFB', transform: 'rotate(-45deg)', fontSize: '19px', cursor: 'pointer' }}
                                onClick={() => console.log(`Attach resume for ${candidate.candidateId}`)}
                              ></i>
                            </td>
                            <td>
                              <div className="d-flex gap-2">
                                <i
                                  className="fa-solid fa-eye action-icon"
                                  title="View"
                                  style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center' }}
                                  onClick={() => navigate(`/view-candidate-progress/${candidate.candidateId}`)}
                                ></i>
                                {/* <i
                                  className="fa-regular fa-pen-to-square action-icon"
                                  title="Edit"
                                  style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center' }}
                                  onClick={() => navigate(`/edit-candidate/${candidate.candidateId}`)}
                                ></i> */}
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No candidates found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Row>
        </Row>
      </Container>
    </div>
  );
};

export default ExistingCandidateProgress;